export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS';
export const GET_PARTNERS_LIST = 'GET_PARTNERS_LIST';
export const GET_PARTNERS_LIST_SUCCESS = `${GET_PARTNERS_LIST}_SUCCESS`;
export const UPDATE_PARTNERS_SUCCESS = 'UPDATE_PARTNERS_SUCCESS';
